<template>
  <div>
    <Loader v-if="loading" skin="gray"></Loader>
    <v-layout v-else row wrap>

      <v-snackbar
        v-model="snackbar"
        :timeout="5000"
        :top="true"
      >
        Je třeba ověřit, že nejste robot.
      </v-snackbar>

      <v-flex xs12>
        <v-layout row wrap class="blue-grey lighten-5 header-text header-background">
          <v-flex xs12 sm10 offset-sm1>
            <v-layout row align-center wrap>
              <v-flex xs12 sm6 md3 offset-sm1 class="svg-logo">
                <img src="../assets/Systherm_Logo.png" alt="Systherm logo">
              </v-flex>
              <v-flex xs12 sm12 md7 offset-sm1>
                <h1>Kalkulátor úspor při použití izolací DH&nbsp;BOX&nbsp;a&nbsp;FLEXIZOL</h1>
                <h3>Spočítejte si, kolik ušetříte s použitím našich průmyslových izolací.</h3>
                <p class="text-justify">
                  Naše průmyslové izolace DH BOX a FLEXIZOL se prokazatelně zákazníkům vyplácejí. Přesvědčte se sami na základě zadání exaktních čísel přímo z vámi požívané technologie.
                </p>
                <p class="text-justify">
                  Zadejte údaje v jednotlivých rozevíracích boxech a dostanete roční úsporu při požití našich izolací. Pokud Vás tato informace osloví, velice jednoduše Vám připravíme cenovou nabídku vycházející přesně z komponent, které jste zadali pro výpočet.
                </p>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex md10 offset-md1>

        <v-layout row wrap align-center class="mt40b10 plr40">
          <v-flex xs12 sm7 md6 lg4>
            <h2>1. Zvolte použitou technologii:</h2>
          </v-flex>
          <v-flex xs12 sm5 md6 lg8 d-flex>
            <v-select
              :items="data.typy_vytapeni"
              v-model="typVytapeni"
              item-value="rewrite"
              item-text="nazev"
              label="Vyberte variantu"
              outline
              @change="loadSimple"
            ></v-select>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="blue-grey lighten-5 pl24t40 mb10">
          <v-flex xs12>
            <v-layout row wrap>
              <v-flex xs12>
                <h2 class="ml16">2. Zadejte hodnoty</h2>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="mx-2 pl-1 pr-1">
              <v-flex xs12 sm6 md3
              v-for="(item, i) in items"
              :key="i">
                <div class="ml-2 mr-2">
                  <label class="form-label">{{item.name}}</label>
                  <v-text-field
                    solo
                    :label="item.placeholder"
                    type="number"
                    validate-on-blur
                    :rules="item.validateNumber"
                    outline
                    class="elevation-0"
                    v-model="item.hodnota"
                    :suffix="item.suffix"
                    @change="loadSimple"
                  ></v-text-field>
                </div>
              </v-flex>
              <v-flex xs12 sm6 md6>
                <div class="ml-2 mr-2">
                  <label class="form-label">Lokalita</label>
                  <v-autocomplete
                    solo
                    :loading="loading"
                    :items="data.mesta"
                    cache-items
                    hide-no-data
                    hide-details
                    label="Zadej hodnotu"
                    outline
                    class="elevation-0"
                    v-model="hodnotaLokalita"
                    @change="loadSimple"
                  ></v-autocomplete>
                </div>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout class="text-container blue-grey lighten-5 pl24t40" row wrap>

          <v-flex xs12>
            <h2 class="ml16">3. Použité komponenty</h2>
          </v-flex>

          <v-flex xs12 v-if="data == null || data.data == null || data.data.length == 0">
            <p class="ml-3">Nejprve vyberte použitou technologii v kroku č. 1.</p>
          </v-flex>

          <v-flex xs12 sm12 md12 lg6
          v-for="(item, i) in array"
          :key="i" v-if="data.data.length > 0">
            <v-card class="mt-3 mb-3 mx-3 item-wrapper">
              <v-layout row wrap>
                <v-flex xs12 sm12 md4 flex align-center justify-center class="img-wrapper-flex">
                  <div class="img-wrapper">
                    <img :src="loadImage(item.obrazek)" :alt="item.nazev">
                  </div>
                </v-flex>
                <v-flex xs12 sm12 md8>
                  <div class="item-type-wrapper">
                    <v-layout row wrap class="mt-3">
                      <v-flex xs12>
                        <h3 class="item-name">{{item.nazev}}</h3>
                      </v-flex>
                    </v-layout>
                    <div v-for="(a, ai) in item.armatury">
                      <div class="gui-flex">
                        <div class="gui-flex-fill-rest">
                          <v-layout row wrap>
                            <v-flex xs12 sm8 class="p05 pb-3 item-type">
                              <v-select
                                :items="item.polozky"
                                item-value = "nazev"
                                item-text = "nazev"
                                label="DN"
                                outline
                                hide-details
                                v-model="a.hodnota"
                                @change="loadSimple"
                              ></v-select>
                            </v-flex>
                            <v-flex xs12 sm4 class="p05">
                              <v-text-field
                                :suffix="item.jednotka"
                                outline
                                type="number"
                                :rules="jednotkaNumber"
                                class="hack"
                                min="0"
                                hide-details
                                v-model="a.pocet"
                                @change="loadSimple"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </div>
                        <div>
                          <v-btn color="primary" fab flat small class="ml-2 mr-3 elevation-0" @click="item.armatury.splice(ai, 1);loadSimple();"><v-icon>delete</v-icon></v-btn>
                        </div>
                      </div>
                    </div>
                    <v-layout row wrap class="mb-3 mt-3">
                      <v-flex xs12 lg6 class="text-xs-center">
                        <v-btn color="blue darken-2" flat small @click="addArmatura(item)">
                          <v-icon small class="mr-1">add</v-icon> Přidat typ položky</v-btn>
                      </v-flex>
                      <v-flex xs12 lg6 class="text-xs-center">
                        <v-btn color="red darken-3" flat small @click="array.splice(i, 1)"><v-icon small class="mr-1">delete</v-icon> Smazat položku</v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>

          <!--<v-flex xs12 sm6 md6 class="text-center">
            <v-card class="mt-3 mb-3 mx-3 item-wrapper itemAddNew">
              <v-card-text class="pt-4 pl-5 pr-5 pb-2">
                <h2>Přidejte nový</h2>
                <div class="gui-flex">
                  <v-select
                    :items="data.data"
                    item-text = "nazev"
                    label="Vyber typ"
                    v-model="addNew"
                    class="gui-flex-fill-rest"
                    outline
                    return-object
                  ></v-select>
                  <v-btn color="blue darken-2" class="text-center ma-0 ml-3" dark fab @click="addNewClick"><v-icon>add</v-icon></v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>-->
        </v-layout>

        <v-layout row justify-space-between wrap class="mtb40" v-if="usporaProcenta != null && usporaKc != null">
          <v-flex xs12>
            <!--<h3>Díky naší izolaci <span class="red--text">ušetříte {{usporaProcenta}} %</span>, to je <span class="red--text">{{usporaKc}} Kč ročně</span>.</h3>-->
            <h3>Na vámi vybraných armaturách ve vaší technologii<br /><span class="red--text">snížíte tepelné ztráty o {{usporaProcenta}}%, to je {{usporaKc}} Kč za rok</span>.</h3>
            <p class="text-center mb0">
              <strong>
                Máte-li zájem o zaslání cenové nabídky podle vámi vypraných komponent a typu média,<br />vyplňte prosím údaje o své identifikaci a my vám nabídku co nejrychleji zašleme.
              </strong>
            </p>
          </v-flex>
        </v-layout>

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout row wrap class="blue-grey lighten-5 pl24t40" v-if="usporaProcenta != null && usporaKc != null">
            <v-flex xs12>
              <!--<v-layout row justify-space-between wrap>
                <v-flex xs12 class="blue-grey lighten-5">
                  <h2 class="ml16">Vyplňte formulář a my Vám zašleme přesnou kalkulaci a návrh řešení.</h2>
                </v-flex>
              </v-layout>-->
              <v-layout row wrap class="mx-2 pl-1 pr-1">
                <v-flex xs12 sm6 md3 class="form-col form-col__first">
                  <div class="ml-1 mr-1">
                    <v-text-field
                      solo
                      name="name"
                      label="Jméno a příjmení"
                      type="text"
                      validate-on-blur
                      :rules="formName"
                      v-model="formNameInput"
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>
                <!--<v-flex xs12 sm6 md3 class="form-col">
                  <div class="ml-1 mr-1">
                    <v-text-field
                      solo
                      label="IČO"
                      type="number"
                      validate-on-blur
                      :rules="formIco"
                      v-model="formIcoInput"
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>-->
                <v-flex xs12 sm6 md3 class="form-col">
                  <div class="ml-1 mr-1">
                    <v-text-field
                      solo
                      name="email"
                      label="Email"
                      type="email"
                      validate-on-blur
                      :rules="formEmail"
                      v-model="formEmailInput"
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md3 class="form-col form-col__last">
                  <div class="ml-1 mr-1">
                    <v-text-field
                      solo
                      label="Telefon"
                      name="phone"
                      type="tel"
                      validate-on-blur
                      :rules="formTel"
                      v-model="formTelInput"
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs12 sm6 md3 class="form-col form-col__last">
                  <div class="ml-1 mr-1">
                    <v-text-field
                      solo
                      name="company"
                      label="Název firmy"
                      v-model="formNazevFirmy"
                      outline
                    ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs12 class="mobile-checkbox">
                  <v-checkbox
                    label="Chci zpracovat nabídku následné realizace."
                    v-model="checkbox"
                    class="bold"
                  ></v-checkbox>
                </v-flex>
              </v-layout>
              <!--<v-layout row wrap>
                <v-flex xs12 class="pl-3">
                  <vue-recaptcha sitekey="6LeRNnQUAAAAAA0Wnu0IhE_ftsnazMzr_w-UncBG" @verify="verify"></vue-recaptcha>
                </v-flex>
              </v-layout>-->
              <div v-if="odeslano">
                <v-dialog
                  v-model="dialog"
                  width="500"
                  v-if="dialog"
                >

                  <v-card>
                    <v-card-title
                      class="headline green--text text-center text-uppercase font-weight-bold block"
                      primary-title
                    >
                      Přejděte do své e-mailové schránky
                    </v-card-title>

                    <v-card-text
                      class="text-center pt-4 pb-5"
                    >
                      Děkujeme Vám za vyplnění formuláře. <br>
                      Zaslali jsme Vám na e-mail přesnou kalkulaci a návrh řešení.
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="green"
                        flat
                        large
                        class="font-weight-bold"
                        @click="dialog=false"
                      >
                      <v-icon class="mr-2">check</v-icon>
                        Odesláno
                      </v-btn>
                      <v-spacer></v-spacer>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>
            </v-flex>
          </v-layout>
          <v-layout row wrap class="mt-5" v-if="usporaProcenta != null && usporaKc != null">
            <v-flex xs12 class="center">
              <v-flex xs12 sm4 offset-sm4 class="mobile-checkbox">
                <v-checkbox
                  label="Odesláním potvrzuji svůj souhlas se zpracováním osobních údajů výhradně pro potřeby společnosti SYSTHERM s.r.o."
                  v-model="consent"
                  class="bold"
                  :rules="required"
                ></v-checkbox>
              </v-flex>
            </v-flex>
          </v-layout>

        </v-form>

      </v-flex>
    </v-layout>

    <v-layout row wrap v-if="usporaProcenta != null && usporaKc != null">
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs12 class="text-center mt-2 mb-5">
            <v-btn large dark class="elevation-0 btn--send" @click="submit" :loading="loadingButton">
              <strong>Odeslat výpočty na email</strong>
              <v-icon class="ml-1">arrow_right_alt</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row wrap class="blue-grey lighten-5 footer" :class=" { 'mt-5': usporaProcenta == null || usporaKc == null } ">
      <v-flex xs12 class="text-center">
        <img src="../assets/Systherm_Logo.png" alt="Systherm logo" class="logo">
        <p>
          <strong>
            SYSTHERM s.r.o., kalkulátor úspor díky izolaci &copy; 2019
          </strong>
        </p>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import Loader from '@/components/Loader'
  import VueRecaptcha from 'vue-recaptcha'
  export default {
    data: function() {
      return {
        checkbox: false,
        odeslano: false,
        typVytapeni: null,
        valid: false,
        loadingButton: false,
        loading: true,
        dialog: false,
        consent: false,
        data: {},
        items: [
          {
            name: 'Teplota media max',
            placeholder: "Zadejte hodnotu",
            hodnata: null,
            validateNumber: [
              //function (v) { return (!!v && v>=20 && v<=80) || 'Min. hodnota je 20, max. hodnota je 80.'}
              function (v) { return (!!v && v>0) || 'Hodnota je vyžadována.'}
            ],
            suffix: "°C"
          },
          {
            name: 'Teplota media min',
            placeholder: "Zadejte hodnotu",
            hodnota: null,
            validateNumber: [
              //function (v) { return (!!v && v>=20 && v<=80) || 'Min. hodnota je 20, max. hodnota je 80.'}
              function (v) { return (!!v && v>0) || 'Hodnota je vyžadována.'}
            ],
            suffix: "°C"
          },
          {
            name: 'Teplota prostoru instalované technologie',
            placeholder: "Zadejte hodnotu",
            hodnota: null,
            validateNumber: [
              //function (v) { return (!!v && v>=20 && v<=80) || 'Min. hodnota je 20, max. hodnota je 80.'}
              function (v) { return (!!v && v>0) || 'Hodnota je vyžadována.'}
            ],
            suffix: "°C"
          },
          {
            name: 'Cena za GJ',
            placeholder: "Zadejte hodnotu",
            hodnota: null,
            validateNumber: [
              function (v) { return (!!v && v>0) || 'Cena je vyžadována.'}
            ],
            suffix: "Kč"
          }
        ],
        hodnotaLokalita: null,
        usporaProcenta: null,
        usporaKc: null,
        formName: [
          v => !!v || 'Jméno je vyžadováno.'
        ],
        formNameInput: '',
        formIco: [
          function (v) { return (!!v && v>0) || 'IČO je vyžadováno.'}
        ],
        formIcoInput: '',
        formEmail: [
          v => !!v || 'E-mail je vyžadován',
          v => /.+@.+/.test(v) || 'E-mail musí být validní.'
        ],
        formEmailInput: '',
        formTel: [
          function (v) { return (!!v && v>0) || 'Telefonní číslo je vyžadováno.'}
        ],
        formTelInput: '',
        jednotkaNumber: [
          function (v) { return (!!v && v>0) || 'Zadejte pouze čísla.'}
        ],
        required: [
          function (v) { return (!!v) || 'Souhlas je vyžadován'}
        ],
        formNazevFirmy: '',
        formNazevFirmyTimeout: null,
        array: [],
        addNew: null,
        valid: true,
        captcha: null,
        snackbar: false
      }
    },
    mounted: function() {
      this.load();
    },
    watch: {
      typVytapeni () {
        this.loadArmatury();
      }
    },
    methods: {
      load: function() {
        this.loadingTable = true;
        window.API.get("kalkulace/init").then(function(body) {
          this.data = body;
          this.loading = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      loadArmatury () {
        window.API.get("kalkulace/data/"+this.typVytapeni).then(function(body) {
          this.data.data = body;
          for (var $i = 0; $i < this.data.data.length; $i++)
            this.data.data[$i].armatury = [
              {
                hodnota: null,
                pocet: null
              }
            ];
          this.array = window.TH.copy(this.data.data);
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      },
      addNewClick () {
        if (this.addNew != null) {
          this.array.push(this.addNew);
          this.addNew = null;
        }
      },
      loadImage (nazev) {
        //return null;
        try {
          return require("../assets/"+nazev)
        }
        catch(ex) {
          return null
        }
      },
      loadSimple () {
        var $armatury = [];
        this.array.forEach(function(e) {
          e.armatury.forEach(function(a) {
            if (a.hodnota != null && a.pocet != null) {
              $armatury.push({
                nazev: a.hodnota,
                pocet: a.pocet
              });
            }
          });
        });
        if (this.typVytapeni != null && this.hodnotaLokalita != null && this.items.filter((x) => x.hodnota != null).length > 0 && $armatury.length > 0) {
          window.API.post("kalkulace/zakladni",{ captcha: this.captcha, typ_vytapeni: this.typVytapeni, mesto: this.hodnotaLokalita, teplota_vody_max: this.items[0].hodnota, teplota_vody_min:this.items[1].hodnota, teplota_okoli:this.items[2].hodnota, cena_gj: this.items[3].hodnota, typy_armatur: $armatury}).then(function(body) {
            this.usporaProcenta = body.uspora_procenta;
            this.usporaKc = body.uspora_kc;
          }.bind(this)).catch(function(err) {
            console.log(err);
          }.bind(this));
        }
        else {
          this.usporaProcenta = null;
          this.usporaKc = null;
        }
      },
      submit () {
        var $armatury = [];
        this.array.forEach(function(e) {
          e.armatury.forEach(function(a) {
            if (a.hodnota != null && a.pocet != null) {
              $armatury.push({
                nazev: a.hodnota,
                pocet: parseInt(a.pocet)
              });
            }
          });
        });
        if (this.$refs.form.validate()/* && this.captcha != null*/) {
          this.loadingButton = true;
          window.API.post("kalkulace",{typ_vytapeni: this.typVytapeni, mesto: this.hodnotaLokalita, teplota_vody_max: this.items[0].hodnota, teplota_vody_min:this.items[1].hodnota, teplota_okoli:this.items[2].hodnota, cena_gj: this.items[3].hodnota, typy_armatur: $armatury, cele_jmeno:this.formNameInput,ic:this.formIcoInput,email:this.formEmailInput,telefon:this.formTelInput, nazev_firmy: this.formNazevFirmy, chci_kalkulaci: this.checkbox}).then(function(body) {
            this.odeslano = true;
            this.loadingButton = false;
            this.dialog = true;
          }.bind(this)).catch(function(err) {
            console.log(err);
            this.loadingButton = false;
          }.bind(this));
        }
        /*else if (this.captcha == null) {
          this.snackbar = true;
        }*/
      },
      /*verify (response) {
        this.captcha = response;
      },*/
      addArmatura (item) {
        item.armatury.push({hodnota: null, pocet: null})
      },
      valueChanged(v) {
        if (v.pocet != null && parseInt(v.pocet) < 0)
          v.pocet = 0;
        this.loadSimple();
      }
    },
    components: {
      Loader,
      VueRecaptcha
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Calculation.vue